import { aboutInfo } from './mockData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 mb-4">
              <i className="ri-building-2-line text-secondary-600 text-sm"></i>
              <span className="text-secondary-700 text-xs font-medium">品牌故事</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              关于555电影网
            </h2>
            <p className="font-heading text-lg md:text-xl text-primary-600">
              {aboutInfo.subtitle}
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-10">
            <div className="space-y-5">
              {aboutInfo.paragraphs.map((para, idx) => (
                <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {para}
                </p>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="text-center p-4 rounded-xl bg-primary-50">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">2020</div>
                <div className="text-xs text-foreground-500 mt-1">创立年份</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-accent-50">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">20,000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-secondary-50">
                <div className="font-heading text-2xl md:text-3xl font-bold text-secondary-600">50亿+</div>
                <div className="text-xs text-foreground-500 mt-1">累计播放</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-primary-50">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">96.8%</div>
                <div className="text-xs text-foreground-500 mt-1">用户满意度</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}